import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

type MuiBadge = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiBadge'];
  defaultProps?: ComponentsProps['MuiBadge'];
  variants?: ComponentsVariants['MuiBadge'];
};

export const MuiBadge: MuiBadge = {
  styleOverrides: {
    root: {
      alignItems: 'center',
    },
    badge: {
      borderRadius: 4,
      height: 18,
      fontSize: 12,
      position: 'relative',
      marginLeft: 8,
    },
    anchorOriginTopRightRectangular: {
      transform: 'initial',
    },
    anchorOriginBottomRightRectangular: {
      transform: 'initial',
    },
    anchorOriginBottomLeftRectangular: {
      transform: 'initial',
    },
    anchorOriginTopLeftRectangular: {
      transform: 'initial',
    },
    anchorOriginBottomRightCircular: {
      transform: 'initial',
    },
    anchorOriginTopLeftCircular: {
      transform: 'initial',
    },
    anchorOriginTopRightCircular: {
      transform: 'initial',
    },
  },
};
